import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { AppConstants } from '../core/app.constants';
import { AttivitaResponse, Statistica, StatisticheResponse, YearsResponse, } from "../core/core.component";

@Injectable()
export class StatisticheService {

    constructor(private http: Http) { }

    getStatistiche(srmToken: string, reforder?: string, inCorso?: boolean, tipologie?: String[], dtInizio?:Date, dtfine?:Date): Observable<StatisticheResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/statistiche";
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        headers.append('Content-Type', 'application/json');
        const formattedDtinizio = this.formatDateToISO(dtInizio);
        const formattedDtfine = this.formatDateToISO(dtfine);
        let body = {
            reforder: reforder,
            inCorso:inCorso,
            tipologie:tipologie,
            dataInizio:formattedDtinizio,
            dataFine:formattedDtfine
        };
        return this.http.post(url, JSON.stringify(body), { headers: headers }).map((responseData) => responseData.json())
        .do(response => {
            console.log("getStat OK - chiamata riuscita", response);
        });;
    }

    getAttivita(srmToken: string, reforder?: string): Observable<AttivitaResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/statistiche/attivita";
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        headers.append('Content-Type', 'application/json');
        let body = {
            reforder: reforder
        };
        return this.http.post(url, JSON.stringify(body), { headers: headers })
         .map(res => res.json())
        .do(response => {
            console.log("getAttivita OK - chiamata riuscita", response);
        });
    }

    private formatDateToISO(date: Date): string {
        if (!date) return null;
        return date.toISOString();
    }
}


// WEBPACK FOOTER //
// ./src/app/service/statistiche.service.ts